import React from 'react';
import { Button, Modal } from '@syneto/compass-react';
import EditionLicensesList from './editionLicensesList';

/*
 * Shows what an edition gives without offering to change it. Edit is one click away so a reader
 * who spots a wrong tier does not have to close this and find the row again.
 *
 * `suspended` hides the dialog without closing it, while the license form is open on top: only
 * one dialog is on screen at a time, and this one comes back where it was.
 */
const EditionViewModal = (props) => {
	const { edition, catalog, isSaving, suspended, onEdit, onEditLicense, onClose } = props;

	return (
		<Modal show={Boolean(edition) && !suspended} size="lg" onHide={onClose}>
			<Modal.Header>
				<Modal.Title>{edition?.name}</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<dl className="row">
					<dt className="col-3">Code</dt>
					<dd className="col-9">{edition?.code}</dd>

					<dt className="col-3">Description</dt>
					<dd className="col-9">{edition?.description || <span className="text-muted">No description</span>}</dd>
				</dl>

				<EditionLicensesList edition={edition} catalog={catalog} onEditLicense={onEditLicense} />
			</Modal.Body>

			<Modal.Footer>
				<Button role="secondary" onClick={onClose}>Close</Button>
				<Button disabled={isSaving} onClick={() => { return onEdit(edition); }}>Edit</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default EditionViewModal;
